/* 肥後屋 — 「ページトップに戻る」ボタン（HIGOYA-102）
 *
 * 指示: 画面を2画面ぶん下へスクロールした段階でフワッとフェードインする。
 *
 * 表示判定に IntersectionObserver ではなくスクロール位置を使っているのは、
 * 「2画面ぶん」という基準がページ内の特定要素ではなく画面高さに紐づくため。
 *
 * スクロールハンドラで requestAnimationFrame の間引きをしていないのは、
 * やることが「同じ値ならDOMを触らない classList.toggle」1回だけで、
 * レイアウトを読まないため間引く必要が無いから。rAFを挟むと、タブが
 * 非表示のあいだ rAF が止まる環境で状態が更新されないまま残る。
 */
(function () {
  var btn = document.querySelector('.lp-pagetop');
  if (!btn) return;

  function update() {
    btn.classList.toggle('is-visible', window.scrollY >= window.innerHeight * 2);
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();

  btn.addEventListener('click', function (event) {
    event.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
